import { render, staticRenderFns } from "./DataTableDocumentosInscripcionesAgrupado.vue?vue&type=template&id=560338c6"
import script from "./DataTableDocumentosInscripcionesAgrupado.vue?vue&type=script&lang=js"
export * from "./DataTableDocumentosInscripcionesAgrupado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports